export default "__VITE_ASSET__7ccffe84__"